import React from 'react';
import { ErrorBoundedProvider } from 'reactifi-local';
import { Router, Route, hashHistory } from 'react-router';
import createStore from './store/volunteerStore';
import VolunteerContainer from './containers/VolunteerContainer';
import { syncHistoryWithStore } from 'react-router-redux';

export default (props, _railsContext) => {
  const store = createStore(props);
  const history = syncHistoryWithStore(hashHistory, store);
  const reactComponent = (
    <ErrorBoundedProvider store={store}>
      <Router history={history}>
        <Route
          path="/"
          component={VolunteerContainer}
          accountId={props.accountId}
          googleMapsApiKey={_railsContext.googleMapsApiKey}
          viewer={props.viewer}
        />
      </Router>
    </ErrorBoundedProvider>
  );
  return reactComponent;
};
